module.exports = __webpack_public_path__ + "img/withdrawAppDP.840d92ba.svg";